<template>
  <div class="victory">
    <div class="victory-container">
      <div class="close" @click="close()"><p>❌</p></div>
      <h1>Félicitations,&nbsp;vous avez sauvé la nouvelle année&nbsp;!</h1>
      <img src="../../assets/NewYear/Final.png" alt="" />
      <div class="footer">
        <div class="final-info">
          <p>Temps : {{ duration }} minutes</p>
          <p>Indices : {{ hintsNumber }}</p>
        </div>
        <button @click="goLanding()">Retour au menu principal</button>
        <img src="../../assets/logo.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { startTime: Number, hints: Number, userName: String },
  data() {
    return {
      start: this.startTime,
      hintsNumber: this.hints,
      user: this.userName
    };
  },
  methods: {
    goLanding() {
      window.open("https://mystery-and-lock.fr/", "_blank");
    },
    close() {
      this.$emit("update", false);
    }
  },
  computed: {
    duration() {
      const diff = Math.abs(new Date() - this.start);
      return Math.floor(diff / 1000 / 60);
    }
  },
  created() {
    const diff = Math.abs(new Date() - this.start);
    console.log("duration", Math.floor(diff / 1000 / 60));

    this.$http
      .post("https://mystery-engine.herokuapp.com/api/new", {
        game_log: {
          name: this.user,
          duration: Math.floor(diff / 1000 / 60),
          enigme: "le-comte-de-minuit",
          status: "finish",
          hint: this.hintsNumber
        }
      })
      .then(
        function(response) {
          // Success
          console.log("session finished", response.data);
        },
        function(response) {
          // Error
          console.log(response.data);
        }
      );
  }
};
</script>

<style scoped>
.victory {
  position: absolute;
  color: rgb(35, 35, 35);
  height: 100%;
  width: 100%;
  background: rgba(30, 30, 30, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.victory-container {
  overflow: scroll;
  font-family: "IBM Plex Mono", monospace;
  height: 200%;
  width: 60%;
  margin: 5% 20% 5% 20%;
  background: rgb(235, 235, 235);
  text-align: center;
  color: #013aa5;
  padding: 2%;
  border-radius: 10px;
}
.victory img {
  width: 50%;
}
.victory h1 {
  font-size: 180%;
}
.victory p {
  font-size: 100%;
}
.footer {
  display: flex;
  justify-content: space-between;
}
.footer img {
  width: 15%;
}
.final-info {
  text-align: left;
}
.footer button {
  background-color: #023aa5;
  color: rgb(235, 235, 235);
  font-family: "IBM Plex Mono", monospace;
  height: 60px;
  margin-top: 2%;
}
.close {
  position: relative;
  top: -6%;
  right: -51%;
}
.close:hover {
  cursor: pointer;
}
</style>
